export const blockIconsPlacesNightShelter = (
	<span className='material-symbols-outlined'>night_shelter</span>
);
